import React from "react";
import { BrowserRouter as Router } from "react-router-dom";
import { ProviderMachine } from "../Context/contextMachine";
import biometricsMachine from "../StateMachines/biometricsMachine"
import { pathDesktop, pathMobile, windowPathname } from "../shared/Constants/Constants"
import MyRoutes  from './MyRoutes';

const stateMachineMap = {
  [pathDesktop]: biometricsMachine,
  [pathMobile]: biometricsMachine,
};
export function selectStateMachine(pathname) {
  return stateMachineMap[pathname] || biometricsMachine;
}
function Main() {  
  const typeMachine = selectStateMachine(windowPathname);
    return (
      <Router>
        <ProviderMachine typeMachine={typeMachine}>
          <MyRoutes />
        </ProviderMachine>
      </Router>
    );
  }
  export default Main;